import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import HomeCarousel from '../components/HomeCarousel';
import Intro from '../components/Intro';
import Services from '../components/Services';
import Reviews from '../components/Reviews';
import InstagramFeed from '../components/InstagramFeed';
import FAQ from '../components/FAQ';
import Address from '../components/Address';
import LazyMap from '../components/LazyMap';
import SEO from '../components/SEO';

class Home extends Component {
  render() {
    return (
      <section>
        <SEO
          title="Sminkes Budapest — alkalmi, esküvői smink"
          description="Professzionális sminkes szolgáltatások Budapesten, V. kerület (5. kerület), belváros. Alkalmi smink, esküvői smink, egyéni önsminkelés oktatás és sminktanácsadás."
          url="/"
        />
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: 'Mennyibe kerül egy alkalmi smink Budapesten?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'A The Makeup Lab-ban az alkalmi smink ára 20 000 Ft. Ide tartozik a nappali smink, esti smink, szalagavató smink, valamint smink fotózásra és fitness versenyre. A műszempilla felhelyezése feláras.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Mennyibe kerül egy esküvői sminkes Budapesten?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Az esküvői smink csomag ára 60 000 Ft, ami tartalmazza a részletes konzultációt, próbasminket a stúdióban, sminket az esküvő napján, a vőlegény arcának lemattítását, valamint Budapest területén kiszállást.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Mennyi ideig tart egy önsminkelő oktatás?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Az egyéni sminktanácsadás és oktatás körülbelül 3-4 órás, személyre szabott alkalom. Az ára 45 000 Ft, és tartalmaz bőrápolási konzultációt, neszesszer átnézést, sminktechnikák elsajátítását, valamint egy online sminknaplót képekkel és magyarázatokkal.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'LMBTQ-barát a The Makeup Lab?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Igen, a The Makeup Lab egy befogadó, LMBTQ+ barát stúdió Budapesten. Mindenkit szeretettel várunk, függetlenül nemi identitástól vagy szexuális orientációtól. A szolgáltatások személyre szabottak, és az alkalmak mindig Rólad szólnak.',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Lehet kutyát vagy háziállatot hozni a stúdióba?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Igen, a The Makeup Lab állatbarát, kutyabarát stúdió. Szívesen látjuk a szőrös családtagokat is!',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Hol található a The Makeup Lab stúdió?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'A stúdió Budapest belvárosában, az V. kerületben található: 1054 Budapest, Hold utca 21. Könnyen megközelíthető tömegközlekedéssel (M2, M3 metró, 70-es, 78-as troli, 2, 2B, 23-as villamos). Autóval is elérhető, fizetős parkolással (kód: 0501).',
                  },
                },
                {
                  '@type': 'Question',
                  name: 'Ki a The Makeup Lab alapítója?',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'A The Makeup Lab alapítója Schmíz Ági, professzionális sminkes Budapesten. Személyre szabott szolgáltatásokat nyújt, ahol minden alkalom a vendégről szól.',
                  },
                },
              ],
            })}
          </script>
        </Helmet>
        <HomeCarousel />
        <Intro />
        <Services />
        <Reviews />
        <InstagramFeed />
        <FAQ />
        <Address />
        <LazyMap />
      </section>
    );
  }
}

export default Home;
